import api from './api';

const pmmService = {
    list: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.partner_id) params.append('partner_id', filters.partner_id);
        if (filters.account_id) params.append('account_id', filters.account_id);
        if (filters.hotel_id)   params.append('hotel_id',   filters.hotel_id);
        if (filters.active !== undefined) params.append('active', filters.active);
        if (filters.search) params.append('search', filters.search);
        return api.get(`/pmm${params.toString() ? '?' + params.toString() : ''}`);
    },

    getById: (id) => api.get(`/pmm/${id}`),
    create:  (data) => api.post('/pmm', data),
    update:  (id, data) => api.put(`/pmm/${id}`, data),
    remove:  (id) => api.delete(`/pmm/${id}`),

    // Criteria
    listCorporateProfiles:   (pmmId)              => api.get(`/pmm/${pmmId}/corporate-profiles`),
    createCorporateProfile:  (pmmId, data)         => api.post(`/pmm/${pmmId}/corporate-profiles`, data),
    updateCorporateProfile:  (pmmId, profileId, data) => api.put(`/pmm/${pmmId}/corporate-profiles/${profileId}`, data),
    deleteCorporateProfile:  (pmmId, profileId)   => api.delete(`/pmm/${pmmId}/corporate-profiles/${profileId}`),

    listIataProfiles:   (pmmId)              => api.get(`/pmm/${pmmId}/iata-profiles`),
    createIataProfile:  (pmmId, data)         => api.post(`/pmm/${pmmId}/iata-profiles`, data),
    updateIataProfile:  (pmmId, profileId, data) => api.put(`/pmm/${pmmId}/iata-profiles/${profileId}`, data),
    deleteIataProfile:  (pmmId, profileId)   => api.delete(`/pmm/${pmmId}/iata-profiles/${profileId}`),

    listRateCodes:   (pmmId)           => api.get(`/pmm/${pmmId}/rate-codes`),
    createRateCode:  (pmmId, data)      => api.post(`/pmm/${pmmId}/rate-codes`, data),
    updateRateCode:  (pmmId, id, data)  => api.put(`/pmm/${pmmId}/rate-codes/${id}`, data),
    deleteRateCode:  (pmmId, id)        => api.delete(`/pmm/${pmmId}/rate-codes/${id}`),

    listPaymentMethods:   (pmmId)         => api.get(`/pmm/${pmmId}/payment-methods`),
    createPaymentMethod:  (pmmId, data)    => api.post(`/pmm/${pmmId}/payment-methods`, data),
    updatePaymentMethod:  (pmmId, id, data) => api.put(`/pmm/${pmmId}/payment-methods/${id}`, data),
    deletePaymentMethod:  (pmmId, id)      => api.delete(`/pmm/${pmmId}/payment-methods/${id}`),

    // Actions
    listProfileAssignments:   (pmmId)         => api.get(`/pmm/${pmmId}/profile-assignments`),
    createProfileAssignment:  (pmmId, data)    => api.post(`/pmm/${pmmId}/profile-assignments`, data),
    updateProfileAssignment:  (pmmId, id, data) => api.put(`/pmm/${pmmId}/profile-assignments/${id}`, data),
    deleteProfileAssignment:  (pmmId, id)      => api.delete(`/pmm/${pmmId}/profile-assignments/${id}`),

    listRoutingCodes:   (pmmId)         => api.get(`/pmm/${pmmId}/routing-codes`),
    createRoutingCode:  (pmmId, data)    => api.post(`/pmm/${pmmId}/routing-codes`, data),
    updateRoutingCode:  (pmmId, id, data) => api.put(`/pmm/${pmmId}/routing-codes/${id}`, data),
    deleteRoutingCode:  (pmmId, id)      => api.delete(`/pmm/${pmmId}/routing-codes/${id}`),

    listRouting:   (pmmId)         => api.get(`/pmm/${pmmId}/routing`),
    createRouting:  (pmmId, data)    => api.post(`/pmm/${pmmId}/routing`, data),
    updateRouting:  (pmmId, id, data) => api.put(`/pmm/${pmmId}/routing/${id}`, data),
    deleteRouting:  (pmmId, id)      => api.delete(`/pmm/${pmmId}/routing/${id}`),

    // OHIP LOVs
    getOhipAgentTypes:    (pmmId)          => api.get(`/pmm/${pmmId}/ohip-agent-types`),
    searchOhipProfiles:   (pmmId, search, profileType) => {
        const params = new URLSearchParams({ search });
        if (profileType) params.append('profileType', profileType);
        return api.get(`/pmm/${pmmId}/ohip-profiles?${params.toString()}`);
    },
    getOhipRoutingCodes:    (pmmId) => api.get(`/pmm/${pmmId}/ohip-routing-codes`),
    getOhipPaymentMethods:  (pmmId) => api.get(`/pmm/${pmmId}/ohip-payment-methods`),

    // Preview + run
    preview: (pmmId, startDate, endDate, dateType, details = false) => {
        const params = new URLSearchParams({ startDate, endDate, dateType: dateType || 'arrival' });
        if (details) params.append('details', 'true');
        return api.get(`/pmm/${pmmId}/preview?${params.toString()}`);
    },
    run:    (pmmId, data) => api.post(`/pmm/${pmmId}/run`, data),
    runRef: (pmmId)       => api.post(`/pmm/${pmmId}/run-ref`),

    // Run history
    listRuns:      (pmmId)           => api.get(`/pmm/${pmmId}/runs`),
    getRunDetail:  (pmmId, runRef)   => api.get(`/pmm/${pmmId}/runs/${encodeURIComponent(runRef)}`),
};

export default pmmService;
